import React from 'react';
import { Outlet } from 'react-router-dom';
import cn from 'classnames';

export const StandaloneWrapper = props => {
  return (
    <div className={cn('standalone-wrapper')}>
      <Outlet />
    </div>
  );
};
